import { render, staticRenderFns } from "./ReceivableAdjustmentList.vue?vue&type=template&id=52447be7&scoped=true&"
import script from "./ReceivableAdjustmentList.vue?vue&type=script&lang=js&"
export * from "./ReceivableAdjustmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52447be7",
  null
  
)

export default component.exports